import { useSnackbar } from "notistack";
import { BiEditAlt } from "react-icons/bi";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  ADMIN,
  ADMIN_USER,
  ROLE_Deactivate_ACL,
  ROLE_Edit_ACL,
  SALES,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import MainComponent from "../../../../components/ui_comps/MainComponent";

import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";

import BasicDetails from "../BasicDetails";

import CustomModal from "../../../../components/main_comps/custom_modal";
import OnboardedClients from "../OnboardedClients";
import {
  primaryColor,
  colorWhite,
  colorBlack,
} from "../../../../../utility/constants/colorManager";
import { validateEmail } from "../../../../../utility/emailValidator";
import ActivityLogs from "../ActivityLogs";

const ActionComponent = ({
  editRequired = true,
  onClickDeactivate,
  status,
  onClickEdit,
  isEditClicked,
  onClickSave,
  aclData,
  loading,
  step,
}) => {
  return (
    <div style={{ display: "flex" }}>
      {aclData.includes(ROLE_Deactivate_ACL) && !isEditClicked && (
        <CustomButton
          styles={{
            backgroundColor: "white",
            border: "1px solid #1E2234",
          }}
          title={status ? "Deactivate account" : "Activate"}
          textStyles={{ color: "#1E2234" }}
          onClick={onClickDeactivate}
        />
      )}

      {editRequired &&
        aclData.includes(ROLE_Edit_ACL) &&
        (step === 0 || step === 1) && (
          <>
            <CustomButton
              ionDirection="left"
              icon={
                isEditClicked ? null : <BiEditAlt size={16} color="white" />
              }
              styles={{
                backgroundColor: isEditClicked ? "transparent" : "#38369C",
                border: isEditClicked
                  ? "1px solid #1E2234"
                  : "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={isEditClicked ? "Cancel" : "Edit"}
              textStyles={{ color: isEditClicked ? "#1E2234" : "white" }}
              onClick={onClickEdit}
            />

            {isEditClicked && (
              <CustomButton
                styles={{
                  backgroundColor: "#38369C",
                  border: "1px solid #38369C",
                  marginLeft: "10px",
                }}
                title={"Save"}
                textStyles={{ color: "white" }}
                onClick={onClickSave}
              />
            )}
          </>
        )}
    </div>
  );
};

function RoleManagementDetailsIndex() {
  const [currentTab, setCurrentTab] = useState(0);
  const { state } = useLocation();
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [tabs, setTabs] = useState([]);
  const handleTabChange = useCallback((tab) => {
    setCurrentTab(tab);
  }, []);

  const navigate = useNavigate();

  const updateRolemanagement = (
    userId,
    firstName = "",
    lastName = "",
    email = "",
    mobileNumber = ""
  ) => {
    ApiRequestPost.updateRolemanagement({
      userId,
      firstName,
      lastName,
      email,
      mobileNumber,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/role-management");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const changeStatus = (userId, status) => {
    ApiRequestPost.updateAdminStatus({
      userId,
      status,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/role-management");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    const tabs = [
      { name: "Basic Details", key: 0 },
      { name: "Onboarded Clients ", key: 1 },
      { name: "Activiy Logs ", key: 2 },
    ];
    if (
      state?.data?.role?.toUpperCase() === SALES ||
      state?.data?.role?.toUpperCase() === ADMIN_USER ||
      state?.data?.role?.toUpperCase() === ADMIN
    ) {
      setTabs(tabs);
    } else {
      setTabs([
        { name: "Basic Details", key: 0 },
        { name: "Activiy Logs ", key: 2 },
      ]);
    }
  }, []);

  useEffect(() => {
    setIsEditClicked(false);
    setClientDetails({});
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        filterRequired={false}
        backActionRequired={true}
        headerTitle={state?.data?.firstName + " " + state?.data.lastName}
      />
      <CustomTabs
        tabs={tabs}
        backgroundrequired={false}
        activeIndex={currentTab}
        passCurrentTab={(data) => handleTabChange(data)}
        actionComponent={
          <ActionComponent
            editRequired={currentTab === 0}
            onClickDeactivate={() => {
              setOpenCommissionModal(true);
            }}
            status={state?.data?.status}
            step={currentTab}
            onClickEdit={() => {
              setIsEditClicked(!isEditClicked);
            }}
            isEditClicked={isEditClicked}
            aclData={aclData}
            onClickSave={() => {
              if (
                clientDetails?.mobileNumber &&
                clientDetails?.mobileNumber.length !== 10
              ) {
                enqueueSnackbar("Please enter a valid mobile number", {
                  variant: "error",
                });
              } else if (
                clientDetails?.email &&
                !validateEmail(clientDetails.email)
              ) {
                enqueueSnackbar("Please enter a valid email", {
                  variant: "error",
                });
              } else {
                if (
                  !clientDetails?.firstName &&
                  !clientDetails?.lastName &&
                  !clientDetails?.email &&
                  !clientDetails?.mobileNumber
                ) {
                  enqueueSnackbar("Please enter details to update", {
                    variant: "error",
                  });
                } else {
                  updateRolemanagement(
                    state?.data?.userId,
                    clientDetails?.firstName,
                    clientDetails?.lastName,
                    clientDetails?.email,
                    clientDetails?.mobileNumber
                  );
                }
              }
            }}
          />
        }
      />
      {currentTab === 0 ? (
        <BasicDetails
          data={state?.data ?? ""}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...val });
          }}
        />
      ) : currentTab === 1 ? (
        <OnboardedClients userRefId={state?.data?.userId} data={state?.data} />
      ) : currentTab === 2 ? (
        <ActivityLogs userId={state?.data?.userId} />
      ) : (
        ""
      )}

      {openCommissionModal && (
        <CustomModal
          headerTitle=""
          open={openCommissionModal}
          onClose={() => {
            setOpenCommissionModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <div
            style={{
              color: primaryColor,
              fontWeight: "500",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            {`Do you want to ${state?.data?.status ? "disable" : "enable"}
     ${state?.data?.firstName} ${state?.data?.lastName}?`}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <CustomButton
              title="Cancel"
              styles={{
                backgroundColor: colorWhite,
                border: "1px solid black",
                padding: 0,
                height: "auto",
                padding: "13px 10px",
                margin: 10,
              }}
              textStyles={{
                color: colorBlack,
              }}
              onClick={() => setOpenCommissionModal(false)}
            />{" "}
            <CustomButton
              title="Yes"
              styles={{
                backgroundColor: primaryColor,
                border: "none",
                padding: 0,
                height: "auto",
                padding: "15px 40px",
                margin: 10,
              }}
              textStyles={{
                color: colorWhite,
              }}
              onClick={() => {
                changeStatus(state.data.userId, !state.data.status);
              }}
              disabled={false}
              loading={loading}
            />
          </div>
        </CustomModal>
      )}
    </div>
  );
}

export default RoleManagementDetailsIndex;
